import React, { useEffect } from 'react'
import './TransaltionAcceptedModal.scss'
import { useTranslation } from 'react-i18next'
import { notifyGTMConversion } from "../../../../helper/tracking/notifyGTMConversion";

function TransaltionAcceptedModal({ okButtonHandler, transactionId }) {
  const { t, i18n } = useTranslation()
  const isPoland = i18n.language === 'pl'

  // dane do przelewu – lokalnie, bo używane tylko tutaj
  const bankTransferData = {
    bankName: 'Citibank Handlowy',
    accountNumber: '49 1030 0019 0109 8530 0012 5632',
    iban: 'PL49 1030 0019 0109 8530 0012 5632',
  }

  useEffect(() => {
    notifyGTMConversion(
      transactionId.id,
      transactionId.totalCost,
      transactionId.currencyType
    )
  }, [transactionId])

  return (
    <div className="transaltion-accepted-modal">
      <div className="modal-box">

        <h2>
          {isPoland
            ? t('orderDataPage.transactionAcceptedAwaitingPaymentText')
            : t('orderDataPage.transactionAcceptedModalText')}
        </h2>


        {isPoland && (
          <div className="bank-transfer-box mt24">
            <h3>{t('orderDataPage.bankTransferHeader')}</h3>

            <div className="bank-transfer-line">
              <strong>{t('orderDataPage.bankName')}:</strong>
              <span>{bankTransferData.bankName}</span>
            </div>

            <div className="bank-transfer-line">
              <strong>{t('orderDataPage.accountNumber')}:</strong>
              <span>{bankTransferData.accountNumber}</span>
            </div>

            <div className="bank-transfer-line">
              <strong>IBAN:</strong>
              <span>{bankTransferData.iban}</span>
            </div>

            <div className="bank-transfer-line mt8">
              <strong>{t('orderDataPage.transferTitle')}:</strong>
              <span>ZAMOWIENIE - {transactionId.id}</span>
            </div>
          </div>
        )}

        <div className="button-wrapper mt64">
          <button className="button auto-width" onClick={okButtonHandler}>
            {t('orderDataPage.transactionAcceptedModalButton')}
          </button>
        </div>

      </div>
    </div>
  )
}

export default TransaltionAcceptedModal
